import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Calculator } from './components/Calculator/Calculator';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { FloorTypes } from './components/FloorTypes';
import { IncludedSection } from './components/IncludedSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ProcessSection } from './components/ProcessSection';
import { VideoSection } from './components/VideoSection';
import { ReviewsSection } from './components/ReviewsSection';
import { UpsellSection } from './components/UpsellSection';
import { GallerySection } from './components/GallerySection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { WhatsAppFab } from './components/WhatsAppFab';
interface AppProps {
  /** Where the calculator sits relative to the narrative sections. */
  calculatorPlacement?: 'after-hero' | 'after-solution';
  /** Show the before/after projects gallery. */
  showGallery?: boolean;
  /** Show the packs upsell section. */
  showUpsell?: boolean;
}
export function App({
  calculatorPlacement = 'after-hero',
  showGallery = true,
  showUpsell = true
}: AppProps) {
  const calculator = <Calculator data-id="element-0" data-mp="2zmo4r67q0h12" />;
  return <div className="min-h-full w-full bg-cream" data-id="element-1" data-mp="2zng14j956ise">
      <Header data-id="element-2" data-mp="33nq73vwxp979" />
      <main data-id="element-3" data-mp="33ngiabnml835">
        <Hero data-id="element-4" data-mp="33mykhalbelt4" />
        <TrustBar data-id="element-5" data-mp="33oi3h8ycvayl" />
        {calculatorPlacement === 'after-hero' && calculator}
        <ProblemSection data-id="element-6" data-mp="38kgk2adfzoog" />
        <SolutionSection data-id="element-7" data-mp="3dkuv81acbeqp" />
        {calculatorPlacement === 'after-solution' && calculator}
        <FloorTypes data-id="element-8" data-mp="3dii4ozqinw21" />
        <IncludedSection data-id="element-9" data-mp="nvstj3irmlvf" />
        <ComparisonSection data-id="element-10" data-mp="nuhhkgf627t8" />
        <ProcessSection data-id="element-11" data-mp="nvas7sh8xhgn" />
        <VideoSection data-id="element-12" data-mp="sunby4ctm8f0" />
        <ReviewsSection data-id="element-13" data-mp="su43de928wdn" />
        {showUpsell && <UpsellSection data-id="element-14" data-mp="st2kinlsz5ld" />}
        {showGallery && <GallerySection data-id="element-15" data-mp="3685nh1tcguh" />}
        <FaqSection data-id="element-16" data-mp="35ovwnmbgyrj" />
        <FinalCta data-id="element-17" data-mp="34x13f0jn52b" />
      </main>
      <Footer data-id="element-18" data-mp="38b7cycbvyf1" />
      <WhatsAppFab data-id="element-19" data-mp="3ud1glcmeruc7" />
    </div>;
}